import type { ITelemetryItem } from "@microsoft/applicationinsights-web";

// deployment/monitoring queries filter on it; the shared App Insights instance serves other apps too
export const UI_CLOUD_ROLE_NAME = "grs-portal-pom-ui";

const EMAIL_IN_URL = /[^/?#&=\s]+(?:@|%40)[^/?#&=\s]+/gi;
const EMAIL_PLACEHOLDER = ":email";

const URL_FIELDS_BY_BASE_TYPE: Record<string, string[]> = {
  RemoteDependencyData: ["name", "target", "data"],
  PageviewData: ["uri", "refUri"],
};

/** Replaces every email-shaped URL segment or query value, plain or percent-encoded, with `:email`. */
export const scrubEmailsFromUrl = (url: string): string => url.replace(EMAIL_IN_URL, EMAIL_PLACEHOLDER);

/** Telemetry initializer: tags the item with the UI's role and strips emails from URL fields. */
export const applyPortalTelemetryTags = (item: ITelemetryItem): void => {
  item.tags = item.tags ?? [];
  item.tags["ai.cloud.role"] = UI_CLOUD_ROLE_NAME;

  const fields = item.baseType ? URL_FIELDS_BY_BASE_TYPE[item.baseType] : undefined;
  const baseData = item.baseData;
  if (!fields || !baseData) {
    return;
  }

  for (const field of fields) {
    const value = baseData[field];
    if (typeof value === "string") {
      baseData[field] = scrubEmailsFromUrl(value);
    }
  }
};
